export default __webpack_public_path__ + "static/media/1231.172328e1.png";